import { getToken } from '@/libs/session'

export default {
  state: {
    token: getToken(),
    userInfo: {}, /// 用户基本信息
    hasUserInfo: false // 检查是否已经登录并且获取用户信息
  },
  mutations: {
    setUserInfo(state, info) {
      let customAttributeMap = {}
      if (info.customAttributeVoList) {
        for (let item of info.customAttributeVoList) {
          customAttributeMap[item.attributeType] = {};
          customAttributeMap[item.attributeType].numberValue = item.numberValue;
          customAttributeMap[item.attributeType].textValue = item.textValue;
        }
      }

      info.customAttributeMap = customAttributeMap;
      state.userInfo = info;
    },
    setToken(state, token) {
      state.token = token
    },
    setHasUserInfo(state, flag) {
      state.hasUserInfo = flag
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js